export default {
  /**
   * Removes all items from client local storage.
   */
  clear: () => {
    window.localStorage.clear()
  },

  /**
   * Retrieves a named item from client local storage.
   *
   * @param key - Name of the item to retrieve.
   * @return Deserialized value of the item.
   */
  getItem: (key: string) => {
    try {
      const value = window.localStorage.getItem(key)

      if (value === null || value === undefined) {
        return null
      }

      return JSON.parse(value)
    } catch {
      return null
    }
  },

  /**
   * Determines whether an item by a given name exists in client local storage.
   *
   * @param key - Name of the item to test.
   * @return {boolean} Whether the provided key exists in client local storage.
   */
  hasItem: (key: string) => window.localStorage.getItem(key) !== null,

  /**
   * Removes a named item from client local storage.
   *
   * @param key - Name of the item to remove.
   */
  removeItem: (key: string) => {
    window.localStorage.removeItem(key)
  },

  /**
   * Saves a named item and related value to client local storage.
   *
   * @param key - Name of the item to set.
   * @param value - Value of the item to set. Must be serializable.
   */
  setItem: (key: string, value: any) => {
    try {
      window.localStorage.setItem(key, JSON.stringify(value))
    } catch {
      // swallow storage full exception as `getItem` will properly default a not found item
    }
  }
}
